module.exports = __webpack_public_path__ + "img/appStore.a21fa8a8.png";